const resizeObserver = new ResizeObserver( ( entries ) => {
  for ( const entry of entries ) {
    const height = entry.target.scrollHeight
    const parts = window.location.href.split( '/' )
    const id = parts[parts.length - 1]
    const type = parts[parts.length - 2]
    const frontEndUrls = [
      'https://www.wordonfire.org',
      'https://institute.wordonfire.org',
      'https://book.wordonfire.org',
      'https://video.wordonfire.org',
      'https://media.wordonfire.org',
      'https://www.liturgyofthehours.com'
    ]
    frontEndUrls.forEach( ( url ) => {
      window.parent.postMessage(
        { type: type, id: id, iframeHeight: height + 10 },
        url
      )
    } )
  }
} )

const livewireElements = document.querySelectorAll( '[wire\\:id]' )

for ( const element of livewireElements ) {
  resizeObserver.observe( element )
}
